import { TOOLTIP_LOCATIONS } from 'utils/tooltipHelpers'
import { PRACTICE_TYPES } from './constants'

export const createSortButtonArray = (handleOnClick, practiceType) => {
  return [
    {
      handleOnClick,
      sortKey: 'users',
      title: 'Users',
      tooltipLocation:
        practiceType === 'sitewide'
          ? TOOLTIP_LOCATIONS.SITEWIDE_USERS
          : practiceType === 'educator'
          ? TOOLTIP_LOCATIONS.EDUCATOR_PRACTICES_USERS
          : practiceType === 'activity'
          ? TOOLTIP_LOCATIONS.STUDENT_ACTIVITIES_USERS
          : TOOLTIP_LOCATIONS.LAUNCH_USERS,
    },
    {
      handleOnClick,
      sortKey: 'department',
      title: 'Department',
    },
    {
      handleOnClick,
      sortKey: 'pathway1',
      title: 'Pathway 1',
    },
    {
      handleOnClick,
      sortKey: 'pathway2',
      title: 'Pathway 2',
    },
    {
      handleOnClick,
      sortKey: 'pathway3',
      title: 'Pathway 3',
    },
    {
      handleOnClick,
      sortKey: 'pathway4',
      title: 'Pathway 4',
    },
    {
      handleOnClick,
      sortKey: 'totalPracticesDone',
      title:
        practiceType === PRACTICE_TYPES.STUDENT_ACTIVITY
          ? 'Total Activities Done'
          : 'Total Practices Done',
    },
  ]
}
